import { withFormik } from "formik";
import * as Yup from "yup";

const formikEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    goal_type: Yup.string().required("This field is required"),
    goal_category: Yup.object()
      .shape({})
      .required("This field is required")
  }),
  mapPropsToValues: props => ({
    goal_type: props.editedData ? props.editedData.goal_type : "",
    goal_category: props.editedData ? props.editedData.goal_category : ""
  }),

  handleSubmit: values => {},
  displayName: "CustomValidationForm",
  enableReinitialize: true,

  isInitialValid: props => (props.editedData ? true : false)
});

export default formikEnhancer;
